import i18n from '@/i18n';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import minMax from 'dayjs/plugin/minMax';
dayjs.extend(minMax);
dayjs.extend(customParseFormat);
import store from '@/store';
import S_scope from "@/service/api/v1/scope";
import S_answerSettingItem from '@/service/api/v1/answerSettingItem';
import H_file from '@/helpers/file';
import H_time from '@/helpers/time';
import H_common from '@/helpers/common';
import H_checklist from '@/helpers/checklist';
import H_systemClassMenu from '@/helpers/systemClassMenu';
import H_checklistAssignment from '@/helpers/checklistAssignment';
import H_guidelineVersionAdmin from '@/helpers/guidelineVersionAdmin';

export default {
  getRiskNum(riskScore, quesList) {
    return quesList.filter(ques => ques.answerRisk.score == riskScore).length;
  },
  getConclusionList(effects, quesList, riskLevelList) {
    const effectList = [...effects];
    effectList.push({
      id: 'keypoint',
      name: '重點關注',
    });
    const invalidEffectNum = [
      {key: 'majorNum', value: [0]},
      {key: 'minorNum', value: [0]},
      {key: 'ofiNum', value: [0]},
      {key: 'passNum', value: [0, 1]},
    ];
    const ConclusionList = [];
    effectList.forEach(effect => {
      const conclusion = {
        leadingImage: effect.icon,
        text: effect.name,
      };
      riskLevelList.forEach((risk) => {
        conclusion[`${risk.value}Num`] = this.getEffectNum(
          effect,
          quesList,
          risk.score,
        );
      });
      let isEffectNumHide = true;
      if (effect.id !== 'keypoint') {
        invalidEffectNum.forEach(invalid => {
          if (!invalid.value.includes(conclusion[invalid.key])) isEffectNumHide = false;
        })
      } else {
        invalidEffectNum.forEach(invalid => {
          if (conclusion[invalid.key] !== 0) isEffectNumHide = false;
        })
      }
      if (isEffectNumHide) return;
      ConclusionList.push(conclusion)
    });
    return ConclusionList;
  },
  getEffectNum(effect, quesList, riskScore) {
    let _quesList = [];
    if (effect.id === 'keypoint') {
      _quesList = quesList.filter( ques =>
        ques.isInStats && ques.keypoint !== null && ques.keypoint && ques.answerRisk.score == riskScore
      );
    } else {
      const { type: effectType, id: effectId } = effect;
      if (effectType === 'effects') {
        _quesList = quesList.filter( ques => {
          return ques.isInStats &&
            ques.effects[0] &&
            ques.effects[0].length &&
            ques.effects[0].filter(effect => effect.id == effectId).length &&
            ques.answerRisk.score == riskScore
        });
      } else if (effectType === 'factoryEffects') {
        _quesList = quesList.filter( ques => {
          return ques.isInStats &&
            ques.effects[1] &&
            ques.effects[1].length &&
            ques.effects[1].filter(effect => effect.id == effectId).length &&
            ques.answerRisk.score == riskScore
        });
      }
    }
    return _quesList.length;
  },
  setRecord(rawRecord, factorySystemClassRows = []) {
    const {
      checkers,
      checklist,
      checklist_version: checklistVersion,
      created_at: createdAt,
      id,
      file_images,
      name,
      pass_rate,
      remark,
      reviewers,
      risk_level: riskLevelScore,
      status,
      system_classes: systemClasses,
      system_subclasses,
      factory_system_classes: factorySystemClasses,
      factory_system_subclasses,
      updated_user: updatedUser,
      updated_at: updatedAt,
      level_payload,
      effect_payload,
      keypoint_payload,
    } = rawRecord;
    const updaters = checkers.map(checker => {
      const { id, name, avatar } = checker;
      if (updatedUser && updatedUser.id === id) {
        return {
          id, name, avatar,
          subTextLabel: '已完成',
          time: `(${H_time.getDateDashFormat(updatedAt, 'YYYY-MM-DD HH:mm:ss')})`
        };
      } else {
        return { id, name, avatar };
      }
    })
    const riskLevelList = store.state.model.checklistRiskLevelList.filter(risk => risk.type == 'question');
    const resultRecord = {
      id,
      title: name,
      remark,
      images: H_file.setShowInModule(file_images),
      checklistId: checklist ? checklist.id : null,
      checklistVersionId: checklistVersion ? checklistVersion.id : null,
      createdAt: H_time.getDateDashFormat(createdAt, 'YYYY-MM-DD HH:mm:ss'),
      reviewers: reviewers.map(reviewer => {
        const { id, name, avatar } = reviewer;
        return { id, name, avatar };
      }),
      checkers: checkers.map(checker => {
        const { id, name, avatar } = checker;
        return { id, name, avatar };
      }),
      riskLevel: riskLevelList.find(risk => riskLevelScore ? risk.score == riskLevelScore : risk.score === null),
      status,
      systemClasses,
      multiSystemClasses: H_systemClassMenu.formatMultiSystemClassContentChips(
        {
          system_classes: systemClasses,
          system_subclasses,
          factory_system_classes: factorySystemClasses,
          factory_system_subclasses,
        },
        { factorySystemClassRows, color: 'medium-blue' },
      ),
      updater: updaters,
      duration: H_checklist.setAssignmentDuration(rawRecord),
      pass_rate,
      level_payload,
      effect_payload,
      keypoint_payload,
    };
    return resultRecord;
  },
  setRecordQuesList(rawDataList) {
    return rawDataList.map(({
      id,
      title,
      sequence,
      answer_value,
      risk_level,
      keypoint,
      updated_at,
      updated_user,
      question_type_setting: quesType,
      is_in_stats: isInStats,
      remark,
      file_images,
      ip,
      lat,
      lng,
      is_completed: isCompleted,
    }) => {
      const _checker = {
        ...updated_user,
        subTextLabel: '已完成',
        time: H_time.getDateDashFormat(updated_at,'YYYY-MM-DD HH:mm:ss'),
      };
      const answerValue = quesType.value === 'date'
        ? H_time.getDateDashFormat(answer_value, 'YYYY-MM-DD HH:mm:ss')
        : quesType.value === 'single-choice'
        ? answer_value.map(answer => answer.name).join()
        : quesType.value === 'text'
        ? answer_value.slice(0, 3)
        : answer_value;
      const answerResult = quesType.value === 'date'
        ? H_time.getDateDashFormat(answer_value, 'YYYY-MM-DD HH:mm:ss')
        : quesType.value === 'single-choice'
        ? answer_value.map(answer => answer.name).join()
        : answer_value;
      const titleObject = {
        text: title,
        chips: [],
      };
      if (keypoint) titleObject.chips.push({
        color: 'green',
        name: '重點關注',
        leadingIcon: 'icon-remind-outline',
      });
      if (!isInStats) titleObject.chips.push({
        color: 'yellow',
        name: '不列入統計',
      });
      return {
        id,
        title,
        titleObject,
        sequence,
        answerValue,
        answerResult,
        answerRisk: H_checklistAssignment.setRiskLevelFromScore(risk_level),
        keypoint,
        checker: _checker,
        answerer: _checker,
        read: {
          icon: 'icon-visibility',
          color: 'light-gray',
        },
        quesType,
        isInStats,
        answerRemark: remark,
        answerImages: H_file.setShowInModule(file_images),
        ip,
        lat,
        lng,
        isCompleted,
      };
    })
  },
  setSampleAndReviewList(rawRecord, type) {
    const currentUserId = store.state.stone_auth.currentUser.id;
    const rawRecordList = type === 'sample'
      ? rawRecord.checklist_sample_records
      : type === 'review'
      ? rawRecord.checklist_review_records
      : rawRecord;
    const recordList = rawRecordList.map(_rawRecord => {
      const {
        score,
        id,
        content,
        attaches,
        record_at: recordAt,
        recorder,
        checklist_record: checklistRecord,
      } = _rawRecord;
      let belongRecordAt = [];
      if (checklistRecord) {
        belongRecordAt = [{
          id: checklistRecord.id,
          text: H_time.getDateDashFormat(checklistRecord.record_at, 'YYYY-MM-DD HH:mm:ss')
        }];
      }
      const record = {
        id,
        score: score === 10
          ? {
              icon: 'icon-check-circle-filled',
              color: 'green',
            }
          : {
              icon: 'icon-cancel',
              color: 'red',
            },
        scoreValue: score,
        content,
        recordAt: H_time.getDateDashFormat(recordAt, 'YYYY-MM-DD HH:mm:ss'),
        recorder,
        attaches: H_file.setShowInModule(attaches),
        belongRecordAt,
      }
      if (recorder.id == currentUserId) {
        record.edit =  {
          icon: 'icon-edit-pencil',
          color: '',
        };
        record.delete = {
          icon: 'icon-delete',
          color: 'red',
        };
      }
      return record;
    });
    return recordList;
  },
  setRecordList(rawRecordList) {
    const recordList = rawRecordList.map((record) => {
      const {
        id,
        risk_level: riskLevelScore,
        pass_rate: passRate,
        reviewers,
        status,
        name: title,
        record_at,
      } = record;
      const riskLevelList = store.state.model.checklistRiskLevelList.filter(risk => risk.type == 'result');
      const riskLevel = status == 1
        ? riskLevelList.find(risk => risk.score === null)
        : riskLevelScore === null
        ? {
            icon: 'icon-check-circle-filled',
            color: 'gray',
            text: '不涉及風險或不列入統計'
          }
        : riskLevelList.find(risk => risk.score == riskLevelScore);
      const {icon, color, text} = riskLevel;
      return {
        result: {icon, color, text},
        id,
        passRate: status == 1
          ? '不需點檢'
          : passRate !== undefined && passRate !== null
          ?`${passRate}%`
          : '-%',
        checkers: H_checklist.setCheckerFromUpdatedUser(record),
        reviewers: H_checklist.setAnswerReviewRecord(reviewers, 'review'),
        download: [
          {
            text: `${i18n.t('匯出')} xlsx`,
            value: 'xlsx',
            id: 2,
          },
          {
            text: `${i18n.t('匯出')} csv`,
            value: 'csv',
            id: 3,
          },
          {
            text: `${i18n.t('匯出與列印')}`,
            value: 'print',
            id: 4,
          },
        ],
        title,
        date: H_time.getDateDashFormat(record_at),
      };
    });
    return recordList;
  },
  setRecordAnalysisTimeDuration(date, frequency, userSetDuration) {
    const { start, end } = userSetDuration;
    const userSetStartDay = dayjs(start);
    const userSetEndDay = dayjs(end);
    const dateRange = {
      start: date,
      end: date,
    };
    if ( frequency === 'week' ) {
      const [startDay, endDay] = date.split('~');
      dateRange.start = startDay;
      dateRange.end = endDay;
    } else if ( frequency === 'month' ) {
      dateRange.start = dayjs(date, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
      dateRange.end = dayjs(date, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
    } else if ( frequency === 'year' ) {
      dateRange.start = dayjs(date, 'YYYY').startOf('year').format('YYYY-MM-DD');
      dateRange.end = dayjs(date, 'YYYY').endOf('year').format('YYYY-MM-DD');
    }
    return {
      start: dayjs.max(userSetStartDay, dayjs(dateRange.start)).format('YYYY-MM-DD'),
      end: dayjs.min(userSetEndDay, dayjs(dateRange.end)).format('YYYY-MM-DD'),
    }
  },
  countDashIndex(date, preferDashNum) {
    let count = 0;
    let index = -1;

    for (let i = 0; i < date.length; i++) {
      if (date[i] === '~') {
        count++;
        if (count === preferDashNum) {
          index = i;
          break;
        }
      }
    }
    return index;
  },
  setAnalysisRecordList(rawRecordList, factorySystemClassRows = []) {
    const scopeSample = S_scope.$_isAvailable(["checklist-sample-record"]);
    const resultRecordList = rawRecordList.map(rawRecord => {
      const {
        id,
        risk_level: riskLevelScore,
        system_classes,
        system_subclasses,
        factory_system_classes,
        factory_system_subclasses,
        name: title,
        pass_rate: passRate,
        reviewers,
        record_at,
        status,
      } = rawRecord;
      const riskLevelList = store.state.model.checklistRiskLevelList.filter(risk => risk.type == 'result');
      const result = status == 1
        ? riskLevelList.find(risk => risk.score === null)
        : riskLevelScore === null
        ? {
            icon: 'icon-check-circle-filled',
            color: 'gray',
            text: '不涉及風險或不列入統計'
          }
        : riskLevelList.find(risk => risk.score == riskLevelScore);
      let reviewStatus = i18n.t('尚未覆核');
      reviewers.forEach(reviewer => {
        if (reviewer.checklist_review_record) {
          reviewStatus = i18n.t('已覆核');
        }
      })
      const resultRecord = {
        id,
        result,
        multiSystemSubclasses: H_systemClassMenu.formatMultiSystemClassContentChips(
          {
            system_classes,
            system_subclasses,
            factory_system_classes,
            factory_system_subclasses,
          },
          { factorySystemClassRows },
        ),
        title,
        passRate: status == 1
          ? '不需點檢'
          : passRate !== undefined && passRate !== null
          ?`${passRate}%`
          : '-%',
        checkers: H_checklist.setCheckerFromUpdatedUser(rawRecord),
        reviewers: H_checklist.setAnswerReviewRecord(reviewers, 'review'),
        reviewStatus,
        download: [
          {
            text: `${i18n.t('匯出')} xlsx`,
            value: 'xlsx',
            id: 2,
          },
          {
            text: `${i18n.t('匯出')} csv`,
            value: 'csv',
            id: 3,
          },
          {
            text: `${i18n.t('匯出與列印')}`,
            value: 'print',
            id: 4,
          },
        ],
        date: H_time.getDateDashFormat(record_at),
        duration: H_checklist.setAssignmentDuration(rawRecord),
      };
      resultRecord.sample = {
        text: scopeSample && rawRecord.status !== '1' ? i18n.t('抽檢') : ''
      };
      return resultRecord;
    });
    return resultRecordList;
  },
  setAnalysisAssignmentList(rawAssignmentList, factorySystemClassRows = []) {
    const resultAssignmentList = rawAssignmentList.map(rawAssignment => {
      const {
        checklist,
        checkers,
      } = rawAssignment;
      const {
        system_classes,
        system_subclasses,
        factory_system_classes,
        factory_system_subclasses,
      } = checklist;
      return {
        multiSystemSubclasses: H_systemClassMenu.formatMultiSystemClassContentChips(
          {
            system_classes,
            system_subclasses,
            factory_system_classes,
            factory_system_subclasses,
          },
          { factorySystemClassRows },
        ),
        title: checklist.name,
        checkers,
        date: H_time.getDateDashFormat(rawAssignment.record_at),
        duration: H_checklist.setAssignmentDuration(rawAssignment),
      };
    })
    return resultAssignmentList;
  },
  getSampleColumnHeader(usedIn) {
    const columnHeader = [
      {
        id: 'score',
        textLabel: i18n.t('結果'),
        type: 'icon',
        tabletHide: false,
        width: '50px',
      },
      {
        id: 'recorder',
        textLabel: i18n.t('抽檢者'),
        type: 'avatar',
        tabletHide: false,
        width: '100px',
      },
      {
        id: 'recordAt',
        textLabel: i18n.t('時間'),
        type: 'text',
        tabletHide: false,
        width: '150px',
      },
      {
        id: 'content',
        textLabel: i18n.t('內容'),
        type: 'text',
        tabletHide: false,
        width: 'auto'
      },
      {
        id: 'attaches',
        textLabel: i18n.t('附件'),
        type: 'attaches',
        tabletHide: false,
        width: '400px',
      },
      {
        id: 'edit',
        type: 'iconBtn',
        tabletHide: false,
        width: '50px',
      },
      {
        id: 'delete',
        type: 'iconBtn',
        tabletHide: false,
        width: '50px',
      },
    ];
    if (usedIn === 'show') {
      columnHeader.splice(4, 0, {
        id: 'belongRecordAt',
        textLabel: i18n.t('相關記錄'),
        type: 'buttons',
        tabletHide: false,
        width: '150px'
      });
    }
    return columnHeader;
  },
  async showAnswerRelatedQuesInfo(rawData) {
    const {
      checklist_question,
      checklist_question_version: quesVersion,
      remark,
      effects,
      factory_effects: factoryEffects,
      question_remark: quesRemark,
      question_template_attaches: quesTempAttaches,
      ocap_remark: ocapRemark,
      file_images,
      file_question_attaches,
      file_ocap_attaches,
      is_in_stats,
      question_type_setting: quesType,
      answer_setting: answerSetting,
      unit,
      record_answer_items,
      related_guidelines,
    } = rawData;
    const lawLinks = H_common.setLawList(rawData);
    const _tempAttaches = quesTempAttaches.map(attach => {return {url: attach}});
    let quesInfo = {
      quesId: checklist_question ? checklist_question.id : '',
      lastVersionId: quesVersion ? quesVersion.id : null,
      answerRemark: remark,
      answerImages: H_file.setShowInModule(file_images),
      remark: quesRemark,
      tempAttaches: _tempAttaches,
      allAttaches: [
        ...H_file.setTempFileShowInModule(quesTempAttaches),
        ...H_file.setShowInModule(file_question_attaches)
      ],
      ocapRemark: ocapRemark ? ocapRemark : '無',
      ocapAttaches: H_file.setShowInModule(file_ocap_attaches),
      effects: [effects, factoryEffects],
      factoryEffects,
      lawLinks,
      lawList: lawLinks.length ? null : '無',
      isInStats: is_in_stats === 1 ? '是' : '否',
      quesType,
      guidelineList: H_guidelineVersionAdmin.setShowRelatedGuideline(related_guidelines),
    };
    if (quesType.value === 'num') {
      const numConditionType = answerSetting;
      quesInfo = {
        ...quesInfo,
        unit,
        numConditionType,
      };
      if (numConditionType.type === 'control-limit') {
        const {
          control_limit_lower: controlLimitLower,
          control_limit_upper: controlLimitUpper,
          spec_limit_lower: specLimitLower,
          spec_limit_upper: specLimitUpper
        } = record_answer_items[0];
        quesInfo = {
          ...quesInfo,
          ...H_checklist.setLimitData({
            controlLimitLower,
            controlLimitUpper,
            specLimitLower,
            specLimitUpper
          }),
        };
      } else if (numConditionType.type === 'custom-num') {
        await S_answerSettingItem.updateOperatorListInVuex(numConditionType.id);
        quesInfo.conditionList = record_answer_items.map(({limit_lower, limit_upper, risk_level, value, value_operator}) => {
          return {
            lowVal: value_operator === 'in' || value_operator === 'not_in' ? limit_lower : value,
            highVal: value_operator === 'in' || value_operator === 'not_in' ? limit_upper : null,
            risk: H_checklist.setRiskLevelText(risk_level),
            riskValue: risk_level,
            operator: H_checklist.setOperatorText(value_operator),
            operatorValue: value_operator,
          };
        });
      }
    } else if (quesType.value === 'single-choice') {
      quesInfo.optionList = record_answer_items.map(({name: title, answer_setting_item: answerSettingItem, common_choice: commonChoice, has_child, has_remark, id, risk_level, record_answer_items}) => {
        const option = {
          id,
          title,
          answerSettingItem,
          commonChoice,
          hasSubOption: has_child === 1,
          requiredRemark: has_child === 1 ? false : !!has_remark,
          risk: H_checklist.setRiskLevelText(risk_level),
          riskValue: risk_level,
          subOptionList: [],
        };
        if (has_child) {
          option.subOptionList = record_answer_items.map(({name: title, answer_setting_item: answerSettingItem, common_choice: commonChoice, has_remark, id, risk_level}) => ({
            id,
            title,
            answerSettingItem,
            commonChoice,
            requiredRemark: !!has_remark,
            risk: H_checklist.setRiskLevelText(risk_level),
            riskValue: risk_level,
          }));
        }
        return option;
      });
    }
    return quesInfo;
  }
}
